/**
 * Created by Mehraz on 2017-09-14.
 */
import {store} from '../store'
// import {router} from '../router'

export default (to, from, next) => {
  if (store.getters.user) {
    next()
  } else {
    // let currentRoute = router.currentRoute
    // store.dispatch('setRoutingLink', currentRoute)
    next('/signin')
  }
}
